"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USE_GRANULAR_HOME_SCOPES = exports.USE_SIMPLE_MENUS_FOR_NON_ADMINS = exports.USE_GRANULAR_SIDEBAR_SCOPES = void 0;
exports.USE_GRANULAR_SIDEBAR_SCOPES = process.env.USE_GRANULAR_SIDEBAR_SCOPES === "true";
exports.USE_SIMPLE_MENUS_FOR_NON_ADMINS = process.env.USE_SIMPLE_MENUS_FOR_NON_ADMINS === "true";
exports.USE_GRANULAR_HOME_SCOPES = process.env.USE_GRANULAR_HOME_SCOPES === 'true';